import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import './UploadAvatar.css'; // Your custom styles
import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';

function AboutUsAuth() {


    return (
        <div>


            <NRDRUHSHeader />

            <Helmet>
                <link rel="canonical" href="https://nrdruh.in/aboutus" />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            {/* ISSN Content */}
            <div className="container" style={{ paddingTop: 60 }}>
                <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>About NRD</h2>
            </div>

            <div className="container">
                <div className="row" style={{ marginBottom: 120 }}>
                    <div className="col-md-2" style={{ padding: 30 }}></div>

                    <div className="col-md-8" style={{ padding: 15, textAlign: 'center' }}>
                        <p style={{ textAlign: 'justify', lineHeight: 2.1 }}>
                            <b style={{ textAlign: 'center' }}>National Research Denticon – ISSN Print 2395-6844</b><br /><br />
                            National research denticon is an official journal of Rajasthan University of Health Sciences, Jaipur.
                            It is a peer-reviewed journal published on behalf of the RUHS College of Dental Sciences, Jaipur,
                            covering a wide spectrum of topics in dentistry, head and neck research, and recent scientific advancements.
                            <br /><br />

                            <b style={{ textAlign: 'center' }}>Aims and Objectives</b>
                            <br /> <br />
                            The journal aims to cover the multifaceted aspect of dentistry.
                            <br /> <br />
                            It offers to give a comprehensive exposure to oral maxillofacial region health and diseases. Its scope includes Pedodontia, Orthodontia, Periodontia, Prosthodontia, Oral and maxillofacial Surgery, Medicine, Radiology and Pathology Conservative dentistry and Endodontics , Public Health dentistry, Forensic odontology, Oral implantology and Aesthetic dentistry.
                            <br /> <br />
                            Articles on original research, clinical diagnostics and experimental research offering high quality scientific exposure incorporating latest update would be considered for publication.

                            <br /><br />
                        </p>
                    </div>

                    <div className="col-md-2" style={{ padding: 15 }}></div>
                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default AboutUsAuth;
